import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'

import Contenido from '@/components/Contenido.vue';
import Usuario from '@/components/Usuario.vue';
import UsuarioRegistro from '@/components/UsuarioRegistro.vue';
import UsuarioRestablecerContrasena from '@/components/UsuarioRestablecerContrasena.vue';
import UsuarioMiSeleccion from '@/components/UsuarioMiSeleccion.vue';
import UsuarioMiPedido from '@/components/UsuarioMiPedido.vue';
import UsuarioMisConsultas from '@/components/UsuarioMisConsultas.vue';
import UsuarioMisConsultasPedido from '@/components/UsuarioMisConsultasPedido.vue';
import UsuarioMisConsultasPedidoReferencia from '@/components/UsuarioMisConsultasPedidoReferencia.vue';
import UsuarioMisConsultasPedidoReferenciaSustituciones from '@/components/UsuarioMisConsultasPedidoReferenciaSustituciones.vue';

import SustitucionesConPropuestas from '@/components/usuario/SustitucionesConPropuestas.vue';
import SustitucionesSinPropuestas from '@/components/usuario/SustitucionesSinPropuestas.vue';
import SustitucionesRechazadas from '@/components/usuario/SustitucionesRechazadas.vue';
import SustitucionesAceptadas from '@/components/usuario/SustitucionesAceptadas.vue';

import UsuarioMisConsultasArticulos from '@/components/UsuarioMisConsultasArticulos.vue';
import UsuarioMisConsultasAlbaran from '@/components/UsuarioMisConsultasAlbaran.vue';
import UsuarioMisConsultasProyecto from '@/components/UsuarioMisConsultasProyecto.vue';
import UsuarioPoliticaDatos from '@/components/UsuarioPoliticaDatos.vue';
import UsuarioCondicionesUso from '@/components/UsuarioCondicionesUso.vue';
import BuscadorAvanzado from '@/components/BuscadorAvanzado.vue';
import Tmp from '@/components/Tmp.vue';

import UsuarioMisConsultasPedidoViejo from '@/components/UsuarioMisConsultasPedido.vue';

Vue.use(VueRouter)



async function checkAuth(to, from, next) {
	router.app.$store.commit('setLocale', to.params.language)
	//console.log('checkAuth')
	//console.log('LoggedIn: ' + store.state.loggedIn)	

	if ( sessionStorage.reload === 'true' ){
		//console.log('reload true')
		let data = false
		const response = await router.app.$store.dispatch('getUserHash', to.params.language)
		data = await response

		if( data ){
			/* console.log('Response' + response)
			console.log('LoggedIn: ' + store.state.loggedIn)			
			console.log('reload false') */
			sessionStorage.reload = 'false'
			next()
		}else{
			if( to.meta.requiresAuth == true ){
				//console.log('else to.meta.requiresAuth == true')
				// Sesión no válida o caducada
				next({ path: '/' + to.params.language, query: { login: true } })	
			}else{
				//console.log('else to.meta.requiresAuth == true else')
				next()
			}
		}
	}else{
		if( to.meta.requiresAuth == true ){
			if( store.state.loggedIn == true ){
				next()
			}else{
				// Sesión no válida o caducada
				next({ path: '/' + to.params.language, query: { login: true } })
			}		
		}else{
			// Not restricted route
			// getUserhash on first load becaus it could be an admin login => must init session
			next()				
		}
	}	
} 

const routes = [
  { path : '/:language/usuario/registro', name: 'registro', component: UsuarioRegistro, beforeEnter: checkAuth },
	{ path : '/:language/usuario/restablecer-contrasena', name: 'restablecer', component: UsuarioRestablecerContrasena, beforeEnter: checkAuth },
	{ path : '/:language/usuario/politica-datos', name: 'politica', component: UsuarioPoliticaDatos, beforeEnter: checkAuth },
	{ path : '/:language/usuario/condiciones-uso', name: 'uso', component: UsuarioCondicionesUso, beforeEnter: checkAuth },

	{ path : '/:language/usuario/perfil', name: 'perfil', component: Usuario, meta: { requiresAuth: true }, beforeEnter: checkAuth },

	{ path : '/:language/usuario/mi-seleccion', name: 'seleccion', component: UsuarioMiSeleccion, meta: { requiresAuth: true }, beforeEnter: checkAuth },
	{ path : '/:language/usuario/mi-pedido/:tipo', name: 'pedido', component: UsuarioMiPedido, meta: { requiresAuth: true }, beforeEnter: checkAuth },

	{ path : '/:language/usuario/mis-consultas', name: 'consultas', component: UsuarioMisConsultas, meta: { requiresAuth: true }, beforeEnter: checkAuth,
			children: [
				{ path: 'pedido', name: 'consultas-pedido', component: UsuarioMisConsultasPedido, meta: { requiresAuth: true } },
				{ path: 'pedido-viejo', name: 'consultas-viejo', component: UsuarioMisConsultasPedidoViejo, meta: { requiresAuth: true } },
				{ path: 'pedido/:idConsorcio/:referencia?', name: 'consultas-pedido-referencia', component: UsuarioMisConsultasPedidoReferencia, meta: { requiresAuth: true } },
				{ path: 'pedido/:idConsorcio/:referencia/sustituciones', name: 'consultas-pedido-referencia-sustituciones', component: UsuarioMisConsultasPedidoReferenciaSustituciones, meta: { requiresAuth: true },
					children: [
						{ path: 'con-propuetas', name: 'sustituciones-con-propuestas', component: SustitucionesConPropuestas, meta: { requiresAuth: true } },
						{ path: 'sin-propuetas', name: 'sustituciones-sin-propuestas', component: SustitucionesSinPropuestas, meta: { requiresAuth: true } },
						{ path: 'rechazadas', name: 'sustituciones-rechazadas', component: SustitucionesRechazadas, meta: { requiresAuth: true } },
						{ path: 'aceptadas', name: 'sustituciones-aceptadas', component: SustitucionesAceptadas, meta: { requiresAuth: true } }
					]
				},
				{ path: 'articulos', name: 'consultas-articulos', component: UsuarioMisConsultasArticulos, meta: { requiresAuth: true } },
				{ path: 'albaran', name: 'consultas-albaran', component: UsuarioMisConsultasAlbaran, meta: { requiresAuth: true } },
				{ path: 'proyecto', name: 'consultas-proyecto', component: UsuarioMisConsultasProyecto, meta: { requiresAuth: true } }
			]
	},
	
	{ path : '/:language/catalogo/:category', name: 'catalogo', component: Contenido, beforeEnter: checkAuth,
			children: [
				{ path: 'buscador-avanzado', name: 'buscador-avanzado', component: BuscadorAvanzado },
			] 
	},

	{	path : '/:language/tmp', name: 'tmp', component: Tmp, beforeEnter: checkAuth },	

	{ path: '/es', redirect: '/es/catalogo/indice', beforeEnter: checkAuth },
	{ path: '/en', redirect: '/en/catalogo/indice', beforeEnter: checkAuth },
	{ path: '/ca', redirect: '/ca/catalogo/indice', beforeEnter: checkAuth },

	{ path: '*', redirect: '/es/catalogo/indice', beforeEnter: checkAuth },
];

 
  /* {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( // webpackChunkName: "about" // '../views/About.vue')
  }
] */

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
	if( ['series', 'documentales'].includes(to.params.category) ){
		next({
			name: to.name,
			params: { language: "es", category: "cine" },
			query: to.query
		})
	}else{
		next()
	}

	//console.log(to)

})

export default router



/* router.beforeEach ((to, from, next) => {
  if (to.matched.some(routes => routes.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    //alert(store.getters.getLoggedIn);
    //alert(to.params.language)

    //sessionStorage.reload = false

    //router.app.$store.commit('setLocale', to.params.language)

    //console.log(sessionStorage)

    if( sessionStorage.reload == 'true' ){
      router.app.$store.dispatch('getUserHash').then( response => {
        sessionStorage.reload = false
        if (!store.getters.getLoggedIn) {
          next({
            path: '/'+ to.params.language +'/indice'
            //query: { redirect: to.fullPath }
          })
        } else {
          next()
        }        
      }, error => {
        console.error("Got nothing from server. Prompt user to check internet connection and try again")
      })
    }else{
      if (!store.getters.getLoggedIn) {
        next({
          path: '/'+ to.params.language +'/indice'
          //query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    }     
  } else {
    next() // make sure to always call next()!
  }
}) */


